import styled from '@emotion/styled'

/**
 * Used to center contents with a reasonable max width
 */
export const Center = styled.div`
	align-items: center;
	flex-direction: column;
	max-width: 60ch;
	display: flex;
	box-sizing: content-box;
	margin-left: auto;
	margin-right: auto;
`

export const VCenter = styled.div`
	align-items: center;
	height: 100%;
	display: flex;
`
